/**
 * Déclaration des différentes routes de l'application
 */
import Header from './containers/Layout/Header'
import * as modules from './containers/MyOpenContainers'

function createDefaultPrivateRoute(path, main, title, exact) {
    return {
        path: path,
        exact: exact,
        main: main,
        header: Header,
        title: title,
    };
}

//Routes privées
export const privateRoutes = [
    createDefaultPrivateRoute('/', modules.Home, "Accueil", true),
    createDefaultPrivateRoute('/index.html', modules.Home, "Accueil", true),
    createDefaultPrivateRoute('/fluide', modules.Fluide, "Fluides", true),
    createDefaultPrivateRoute('/absences', modules.Absence, "Absences", true),
    createDefaultPrivateRoute('/absences/createAbsence', modules.CreateAbsence, "Création d'absence", true),
    createDefaultPrivateRoute('/absences/editAbsence', modules.EditAbsence, "Édition d'absence", true),
    createDefaultPrivateRoute('/absences/validateAbsence', modules.ValidateAbsence, "Validation d'absence", true),
    createDefaultPrivateRoute('/activity', modules.Activity, "Saisie des temps", true),
    createDefaultPrivateRoute('/activity/report', modules.ActivityReport, "Rapport d'activité", true),
    createDefaultPrivateRoute('/parameters', modules.Parameters, "Système", true),
    createDefaultPrivateRoute('/analyseRisques', modules.AnalyseRisques, "Analyse de risques", true),
    createDefaultPrivateRoute('/analyseRisques/createAnalyseRisques', modules.CreateAnalyseRisques, "Création d'AR", true),
    createDefaultPrivateRoute('/analyseRisques/editAnalyseRisques', modules.EditAnalyseRisques, "Édition d'AR", true),
    createDefaultPrivateRoute('/pps', modules.SimplifiedPreventionPlans, "Plan de prévention", true),
    createDefaultPrivateRoute('/epis', modules.FollowupEquipmentsEPI, "Suivi équipements/EPI", true),
    createDefaultPrivateRoute('/epis/epi', modules.EquipmentsEPIPreview, "Infos équipements/EPI", true),
    createDefaultPrivateRoute('/epis/epi/form', modules.EquipmentEPIForm, "Formulaire équipements/EPI", true),
    createDefaultPrivateRoute('/epis/declare', modules.DeclareEquipment, "Ajout d'équipement/EPI", true),
    createDefaultPrivateRoute('/pps/createPps', modules.CreateAnalyseRisques, "Création de PPS", true),
    createDefaultPrivateRoute('/pps/editPps', modules.EditAnalyseRisques, "Édition de PPS", true),
    createDefaultPrivateRoute('/carteHabilitation', modules.CarteHabilitation, "Carte d'habilitation", true),
    createDefaultPrivateRoute('/componentsPark', modules.ComponentsPark, "Parc machines", true),
    createDefaultPrivateRoute('/interventions', modules.Interventions, "Interventions", true),
    createDefaultPrivateRoute('/interventions/intervention/preview', modules.InterventionPreview, "Intervention", true),
    createDefaultPrivateRoute('/interventions/intervention/controlSignature', modules.InterventionControlSignature, "Intervention", true),
    createDefaultPrivateRoute('/interventions/intervention/signature', modules.InterventionSignature, "Intervention", true),
    createDefaultPrivateRoute('/interventions/intervention', modules.Intervention, "Intervention", true),
    createDefaultPrivateRoute('/interventions/createIntervention', modules.CreateIntervention, "Intervention", true),
    createDefaultPrivateRoute('/siteMonitorings', modules.SiteMonitorings, "Chantiers", true),
    createDefaultPrivateRoute('/siteMonitorings/siteMonitoring', modules.SiteMonitoring, "Suivi de chantier", true),
    createDefaultPrivateRoute('/humanResources', modules.HumanResources, "Ressources humaines", true),
    createDefaultPrivateRoute('/humanResources/form/:id', modules.HRForm, "Formulaire", true),
    createDefaultPrivateRoute('/humanResources/form', modules.HRForm, "Formulaire", true),
    createDefaultPrivateRoute(undefined, modules.NotFound, "Page 404", false),
];

//Routes publiques (pas besoin d'être identifié)
export const publicRoutes = [
    { path: '/Login', main: modules.Login },
    { path: '/NotFound', main: modules.NotFound },
];
